import { useEffect } from 'react';

import { usePersistentState } from '@cast/utils';

import { useOnboardingWizardForceVisibleOverride } from './onboardingWizardDevOverrides';

const ONBOARDING_WIZARD_HIDE_FOREVER_KEY = 'onboarding-wizard-hide-forever';

export const useOnboardingWizardDismiss = () => {
  const forceVisible = useOnboardingWizardForceVisibleOverride();
  const [hideForever, setHideForever] = usePersistentState(
    ONBOARDING_WIZARD_HIDE_FOREVER_KEY,
    false
  );

  useEffect(() => {
    if (forceVisible === true && hideForever) {
      setHideForever(false);
    }
  }, [forceVisible, hideForever, setHideForever]);

  const effectiveHideForever =
    forceVisible === true ? false : forceVisible === false ? true : hideForever;

  return {
    hideForever: effectiveHideForever,
    forceVisible,
    dismissForever: () => setHideForever(true),
    showAgain: () => setHideForever(false),
  };
};
